import { render, staticRenderFns } from "./TransferClueApply.vue?vue&type=template&id=ded5e798&scoped=true"
import script from "./TransferClueApply.vue?vue&type=script&lang=js"
export * from "./TransferClueApply.vue?vue&type=script&lang=js"
import style0 from "./TransferClueApply.vue?vue&type=style&index=0&id=ded5e798&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded5e798",
  null
  
)

export default component.exports